<template>
<a-space direction="vertical">
    <div class="address-choose">
        <a-button type="link" @click="handleSelect">
        <img class="addressIcon" src="@/assets/img/address.png">从地址库选择
        </a-button>
    </div>
    <div>
        <a-row >
            <a-col :md="8" :sm="24">
                <a-form-model-item
                    label="站点名称"
                    :colon="false"
                >
                    <a-input v-model="endStation.stationName" placeholder="请输入"></a-input>
                </a-form-model-item>
            </a-col>
            <a-col :md="8" :sm="24">
                <FormItemName
                    v-model.trim="endStation.contactName"
                    :scene="scene"
                    :tab="tab"
                    :prop-prefix="propPrefix"
                />
            </a-col>
            <a-col :md="8" :sm="24">
                <FormItemPhone
                    v-model="endStation.contactPhone"
                    :scene="scene"
                    :tab="tab"
                    :prop-prefix="propPrefix"
                />
            </a-col>
            <a-col v-if="scene === warehouseType.in || tab === tabListType.DELIVER_TRANSPORT" :md="8" :sm="24">
                <a-form-model-item
                    label="期望送达时间"
                    :colon="false"
                    :prop='`${propPrefix}.expectTime`'
                    :label-col="{span: 6}"
                    :wrapper-col="{span: 18}"
                    :rules="[
                        { required: true, message: '请选择需要送达时间', trigger: 'change' },
                    ]"
                >
                    <a-date-picker
                    v-model="endStation.expectTime"
                    :disabled-date="disabledDate"
                    :disabled-time="disabledDateTime"
                    :show-time="{ defaultValue: defaultTime }"
                    placeholder="请选择送达时间"
                    @change="handleChange"
                    @focus="handleFocus" />
                </a-form-model-item>
            </a-col>
            <a-col :md="16" :sm="24">
                <!-- <FormItemAddress
                    :address="endStation"
                    :prop-prefix="propPrefix"
                    @change="handleAdressChange" /> -->
                    <a-form-model-item
                        label="联系人地址"
                        :colon="false"
                        :label-col="{span: 3}"
                        :wrapper-col="{span: 21}"
                        :rules="addressRules"
                        :prop="`${propPrefix}.address`"
                    >
                        <address-detil
                        :default-address="defaultAddress"
                        :default-suffix="defaultSuffix"
                        placeholder="请输入目的地地详细地址"
                        @updateData="handleAdressChange"
                        @removeData="removeData"></address-detil>
                    </a-form-model-item>
            </a-col>
        </a-row>
        <slot></slot>
    </div>
    <SelectAddressDialog ref="SelectAddressDialog" :station-type="StationTypes.RECEIVING" @onSelectAddress="handleAdressFromSelectorChange"/>
 </a-space>
</template>
<script>
import moment from 'moment';
import FormValidator from '@/constants/formValidator'
import { mapState } from 'vuex'
import {TIME_UNIT,TIME_UNIT_MAP,range} from '@/constants/ruleConfig'
import {tabListType} from "@/pages/orderManage/constant";
import SelectAddressDialog from '../../../orderManage/components/SelectAddressDialog'
import { StationTypes } from '../../warehouseList/constant';
import AddressDetil from './AddressDetil.vue'

import {
    FormItemName,
    FormItemPhone,
    // FormItemAddress
} from '../../../orderManage/components/FormItem'

const warehouseType = {
    in: 'STORE',
    out: 'DELIVER'
}

export default {
    components: {
        SelectAddressDialog,
        FormItemName,
        FormItemPhone,
        // FormItemAddress,
        AddressDetil,
    },
    model: {
        prop: 'endStation',
        event: 'change'
    },
    props: {
        endStation: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            default: ''
        },
        subtitle: {
            type: String,
            default: ''
        },
        propPrefix: {
            type: String,
            default: ''
        },
        scene: {
            type: String,
            default: ''
        },
        deliverWarehouseCode: {
            type: String,
            default: ''
        },
        shipperCode: {
            type: String,
            default: ''
        },
        tab:{
          type:String,
          default: tabListType.WAREHOUSE
        }
    },
    data () {
        return {
            tabListType,
            warehouseType,
            defaultTime: moment('23:59:59', 'HH:mm:ss'),
            col: 8,
            wrapperCol: 14,
            FormValidator,
            StationTypes,
            addressRules: [
                { required: true, message: '请选择地址', trigger: 'change' },
            ],
            defaultAddress: '',
            defaultSuffix: '',
            current:null,
        }
    },
    computed:{
      ...mapState('orderRules', ['orderRules']),
    },
    watch:{
        endStation:{
            handler(val){
                if(val.expectTimeLeft && val.expectTimeLeft.length>0){
                    this.defaultTime=moment(val.expectTimeLeft[0]||'23:59:59','HH:mm:ss')
                }else{
                    this.defaultTime=moment('23:59:59', 'HH:mm:ss')
                }
                if(val.address){
                    this.defaultSuffix = `${val.provinceName}${val.cityName}${val.countyName}${val.address}`
                    if(!val.name){
                        this.defaultAddress = val.address.replace(`${val.provinceName}${val.cityName}${val.countyName}`, '')
                    } else {
                        this.defaultAddress = val.name
                    }
                } else {
                    this.defaultSuffix = ''
                    this.defaultAddress = ''
                }
            },
            immediate: true
        }
    },
    methods: {
      handleFocus(){
        this.current = new Date();
      },
      handleChange(value){
          if(!value){
            this.$set(this.endStation,'expectTime',null)
            return
          }
          const {createReachTimeNum,createReachTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          // 结束时间
          const endTime =  moment(this.current).add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
         // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          if(isSameEnd){
            if(value > endTime){
              this.$set(this.endStation,'expectTime',moment(endTime))
            }else{
              this.$set(this.endStation,'expectTime',value)
            }
          }else{
            this.$set(this.endStation,'expectTime',value)
          }
      },
        disabledDate(current){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = this.orderRules.ORDER_CREATE_TIME_CHECK;
          let startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current).subtract(1, "days");
          let endTime =moment(this.current).add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          if(makeupReachTimeUnit){
            startTime = moment(startTime).subtract(1 , 'days')
          }
          if(createReachTimeUnit === TIME_UNIT.HOURS){
            endTime = moment(endTime)
          }
          return current && moment(current).startOf('days') < startTime|| moment(current).startOf('days') > endTime
        },
        disabledDateTime(){
          return {
			      disabledHours: () => this.disabledHours(this.orderRules.ORDER_CREATE_TIME_CHECK),
			      disabledMinutes: () => this.disabledMinutes(this.orderRules.ORDER_CREATE_TIME_CHECK),
		      };
        },
        disabledHours(data){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.endStation.expectTime||this.current).isSame(startTime, 'day');
          // 获取当前时间小时
          const currentHours = moment(this.current).hour();
          // 结束时间小时数计算
          const endHours = createReachTimeUnit === TIME_UNIT.HOURS? currentHours + createReachTimeNum:currentHours;
          // 开始时间小时数计算
          const startHours = makeupReachTimeUnit === TIME_UNIT.HOURS? currentHours - makeupReachTimeNum:currentHours;
          // hours数组
          const hoursList = range(0,24);
          // 结束禁用小时列表
          const endDisabledList =  hoursList.splice(hoursList.indexOf(endHours)+1,24);
          // 开始禁用小时列表
          const startDisabledList =  hoursList.splice(0,hoursList.indexOf(startHours));
          if(isSameEnd&&isSameStart){
            return [...startDisabledList,...endDisabledList]
          }
          if(isSameEnd){
            return endDisabledList
          }if(isSameStart){
            return startDisabledList
          }
          return []
        },
        disabledMinutes(data){
          const {flag,createReachTimeNum,makeupReachTimeNum,createReachTimeUnit,makeupReachTimeUnit} = data;
          // 开始时间
          const startTime = flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]):moment(this.current);
          // 结束时间
          const endTime =  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit])
          // 是否跟结束日期相同
          const isSameEnd = moment(this.endStation.expectTime||this.current).isSame(endTime, 'day');
          // 是否跟开始时间相同
          const isSameStart = moment(this.endStation.expectTime||this.current).isSame(startTime, 'day');
          // 开始时间是多少小时
          const startHours= flag ? moment(this.current).subtract(Number(makeupReachTimeNum),TIME_UNIT_MAP[makeupReachTimeUnit]).hour():moment(this.current).hour();
          // 获取当前时间小时
          const currentHours = this.endStation.expectTime? moment(this.endStation.expectTime).hour():startHours;
          // 结束时间是多少小时
          const endHours=  moment().add(+Number(createReachTimeNum),TIME_UNIT_MAP[createReachTimeUnit]).hour()
          if(isSameStart&&currentHours === startHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(0,minuteList.indexOf(endMinute))
            return disabled
          }if(isSameEnd&&currentHours === endHours){
            const endMinute = moment(this.current).minute()
            const minuteList = range(0,60);
            const disabled = minuteList.splice(minuteList.indexOf(endMinute)+1,60)
            return disabled
          }
          return []
        },
        handleSelect() {
            if(this.scene === warehouseType.out){
                if(!this.deliverWarehouseCode) {
                    this.$message.warning('请先选择仓库')
                    return
                }
                this.$refs.SelectAddressDialog.show({
                    data: true,
                    ownerTenantId: this.deliverWarehouseCode,
                    customerCode: this.shipperCode,
                    isWharehose: true
                })
            } else {
                this.$refs.SelectAddressDialog.show({ isWharehose: true,ownerTenantId: this.deliverWarehouseCode, })
            }
        },
        handleAdressFromSelectorChange({
            contacts, telPhone,stationName,
            provinceName, cityName, countyName, address,
            provinceCode, cityCode, countyCode, sourceStationId, maxReceiptPeriodTime
        }) {
            this.update({
                contactPhone: telPhone,
                contactName: contacts,
                provinceName,
                cityName,
                countyName,
                address,
                provinceCode,
                cityCode,
                countyCode,
                stationId: sourceStationId,
                stationName,
                // stationFullAddress: `${provinceName || ''}${cityName || ''}${countyName || ''}${address || ''}`
            })
            // 该站点是否已有收货时段,期望送达时间的结束时间
            if(maxReceiptPeriodTime) {
                this.defaultTime = moment(`${maxReceiptPeriodTime}:00`, 'HH:mm:ss')
            } else {
                this.defaultTime = moment('23:59:59', 'HH:mm:ss')
            }
        },
        handleAdressChange(address) {
            this.update(address)
        },
        update(infos) {
            const {provinceName, cityName, countyName, address} = infos
            this.$emit('change', {
                ...this.endStation,
                ...infos,
                provinceName,
                cityName,
                countyName,
                stationFullAddress: `${provinceName || ''}${cityName || ''}${countyName || ''}${address || ''}`
            })
        },
        removeData(){
            const { contactName, contactPhone, expectTime, crmNumber, mileageKm} = this.endStation
            this.$emit('change', {
                stationId: '',
                provinceName: '',
                cityName: '',
                countyName: '',
                address: '',
                defaultAddress: [],
                orderGoodsType: 0,
                contactName, contactPhone, expectTime, crmNumber, mileageKm,
                stationGoodsList: []
            })
        },
    },
}
</script>

<style lang="less" scoped>
.address-choose {
    padding-left: 32px;
    margin-bottom: 19px;
    .ant-btn {
        padding: 0;
    }
}
.title {
    font-size: 30px;
    font-weight: 500;
}

.subtitle-label{
    display: flex;
    .subtitle {
        flex: 1;
    font-weight: bold;
    font-size: 16px;
    }

}
/deep/ .subtitle-label {
    margin-bottom: 10px;
}
.addressIcon{
    width: 16px;
    margin-top: -2px;
}
.btnStyle{
    margin-top: 8px;
}
/deep/ .ant-space-item{
    margin-bottom: 0 !important;
}
/deep/ .orderNumStyle{
    max-width: 302px !important;
    width: 100%;
}
</style>
